'use client'

import { CircleScoreFluid } from '@/components/client/score/circle-score-fluid'
import { useTranslation } from '@/hooks/client/use-translation'

const SCORE_MAX = 5

interface RowEvidenceProps {
  score: number | null
  slug: string
}

// The expert score wheel, with its source named beside it from md up (on
// phones the wheel's own caption carries that); a quiet "Not yet tested" chip
// when the family has no real rating.
export const RowEvidence = ({ score, slug }: RowEvidenceProps) => {
  const { t } = useTranslation()

  if (score == null || score <= 0) {
    return (
      <span className="bg-navy/5 text-navy/70 inline-flex rounded-full px-2.5 py-1 text-[12px] font-medium whitespace-nowrap">
        {t('directory.row.notRated', 'Not yet rated')}
      </span>
    )
  }

  return (
    <div className="flex items-center gap-3">
      <CircleScoreFluid
        size="sm"
        isStatic
        amount={score}
        progress={(score / SCORE_MAX) * 100}
        className="min-w-[48px] md:min-w-[56px]"
        // The fluid caption drops to 5 px under a 66 px wheel; hold it at 7 px.
        scoreTextClassName="text-[7px]!"
        origin={`directory/${slug}`}
      />
      <span className="text-navy/80 hidden text-[13px] leading-snug md:block">
        {t('directory.row.expertLabel', 'HearingTracker expert assessment')}
      </span>
    </div>
  )
}
